const _excluded = ["children", "className", "header", "subheader", "actions", "loading", "style", "height", "width", "minWidth", "maxWidth", "disableRightGutter", "disableLeftGutter", "skin", "variant", "onClickBack"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React, { useMemo, useState } from 'react';
import cn from 'classnames';
import { PageHeader } from "../PageHeader";
import { PageContentHeaderContext } from "./PageContentHeader";
import styles from "./Page.module.scss";
/** Renders a page to the right of a sidebar. */
export const Page = /*#__PURE__*/React.forwardRef(function Page(props, ref) {
  const {
      children,
      className,
      header,
      subheader,
      actions,
      loading,
      style,
      height,
      width,
      minWidth,
      maxWidth,
      disableRightGutter,
      disableLeftGutter,
      skin = 'primary',
      variant = 'default',
      onClickBack
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const renderedStyle = useMemo(() => _objectSpread(_objectSpread({}, style), {}, {
    '--pageHeight': height,
    width,
    '--min-width': minWidth,
    '--max-width': maxWidth
  }), [style, height, width, minWidth, maxWidth]);
  const [contentHeaderEl, setContentHeaderEl] = useState(null);
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    className: cn(styles.root, styles["".concat(skin, "Skin")], {
      [styles.disableRightGutter]: disableRightGutter,
      [styles.disableLeftGutter]: disableLeftGutter,
      [styles.containedHeight]: variant === 'containedHeight'
    }, className),
    style: renderedStyle,
    ref: ref
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.stickyToTop
  }, header && /*#__PURE__*/React.createElement(PageHeader, {
    title: header,
    loading: loading,
    subheader: subheader,
    actions: actions,
    onClickBack: onClickBack,
    "data-testid": props['data-testid']
  }), /*#__PURE__*/React.createElement("div", {
    ref: setContentHeaderEl
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.content,
    "data-testid": props['data-testid'] && "".concat(props['data-testid'], "-page-content")
  }, /*#__PURE__*/React.createElement(PageContentHeaderContext.Provider, {
    value: contentHeaderEl
  }, children)));
});